<p>supplies-requested works!</p>
<div class="card">
    <h5>Subheader Grouping</h5>
    <p>Group customers by their representative.</p>
    <p-table [columns]="listTableHeader" [value]="listSuppliesReq"  [scrollable]="true" scrollHeight="400px"  responsiveLayout="scroll">
        <ng-template pTemplate="header" let-columns>
            <th *ngFor="let col of columns">
                {{col.header}}
            </th>
        </ng-template>
        <!--
        <ng-template pTemplate="groupheader" let-supplie>
            <tr pRowGroupHeader>
                <td colspan="5">
                    <img [alt]="supplie.itemCat2Desc" src="assets/layout/images/widgets/asset-profile.png" width="32" style="vertical-align: middle" />
                    <span class="p-text-bold p-ml-2">{{supplie.itemCat2Desc}}</span>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="groupfooter" let-supplie>
            <tr class="p-rowgroup-footer">
                <td style="min-width: 80%">
                    <div style="text-align: right; width: 100%">Total Customers</div>
                </td>
                <td style="width: 20%">{{calculateCustomerTotal(supplie.itemName)}}</td>
            </tr>
        </ng-template>
        -->
        <ng-template pTemplate="body" let-rowData let-columns="columns">
            <tr>
                <td *ngFor="let col of columns">
                    {{rowData[col.field]}}
                </td>
            </tr>
            <!--<tr>
                <td >
                    {{supplie.itemId}}
                </td>
                <td >
                    {{supplie.itemName}}
                </td>
                <td >
                    {{supplie.supplName}}
                </td>
                <td >
                    <span >{{supplie.itemCat2}}</span>
                </td>
                <td >
                    {{supplie.appQty}}
                </td>
            </tr>
        -->
        </ng-template>
    </p-table>
</div>